



































































import Vue, { PropType } from 'vue'
import { PropertyMap } from '@/components/gmap/'
import { getNestedValue } from '@/util/helpers'
import { MapMarker } from '@/interfaces/gmap/Map'
import { ValidatedResponse } from '@/interfaces/app/ValueObjects'
import {
  AdvertisingTransactions as AdvertisingTransactionsGrid,
  OffersTransactions as OffersTransactionsGrid,
} from '@/components/grid/'
import { BuildingType } from '@/interfaces/valuation/types/BuildingValuationStep'

export default Vue.extend({
  components: {
    PropertyMap,
    AdvertisingTransactionsGrid,
    OffersTransactionsGrid,
  },
  props: {
    valuationNumber: {
      type: String,
      required: true,
    },
    loadingOffers: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    buildingType(): BuildingType {
      return this.$store.getters['valuationEdit/buildingType']
    },
    isBuildingTypeNew(): boolean {
      return this.buildingType === BuildingType.New
    },
    transactions(): any {
      return this.isBuildingTypeNew
        ? this.$store.getters['valuationEdit/offersTransactions']
        : this.$store.getters['valuationEdit/advertisingTransactions']
    },
    average(): { m2: number; total: number } {
      return this.isBuildingTypeNew
        ? getNestedValue(
            this.$store.getters['valuationEdit/offersData'],
            ['average'],
            { m2: 0, total: 0 }
          )
        : getNestedValue(
            this.$store.getters['valuationEdit/advertisingData'],
            ['average'],
            { m2: 0, total: 0 }
          )
    },
    unitInfo(): any {
      return getNestedValue(
        this.$store.getters['valuationEdit/data'],
        ['info'],
        {}
      )
    },
    unitMarker(): MapMarker | undefined {
      if (this.unitMarkerPosition.valid) {
        const marker: MapMarker = {
          id: 1,
          position: this.unitMarkerPosition.value!,
          icon: require('@/assets/icons/map/pointer–blue.svg'),
        }

        return marker
      }
    },
    unitMarkerPosition(): ValidatedResponse<MapMarker['position']> {
      const lat = getNestedValue(this.unitInfo, ['gpsNumeric', 'lat'], false)
      const lng = getNestedValue(this.unitInfo, ['gpsNumeric', 'lng'], false)

      if (!lat || !lng) {
        return { valid: false }
      }

      return {
        valid: true,
        value: {
          lat: Number(lat),
          lng: Number(lng),
        },
      }
    },
    markers(): MapMarker[] {
      let id = 2
      const markers: MapMarker[] = this.transactions
        .map((t: any) => {
          const lat = getNestedValue(t, ['lat'], false)
          const lng = getNestedValue(t, ['lng'], false)
          let price = getNestedValue(t, ['priceTotal'], 0)
          const filter = getNestedValue(this.$options.filters, ['formatMoney'])

          if (filter) {
            price = filter(price)
          }
          return {
            id: id++,
            position: {
              lat: lat ? Number(lat) : false,
              lng: lng ? Number(lng) : false,
            },
            icon: require('@/assets/icons/map/pointer–green.svg'),
            infoWindow: {
              image: require('@/assets/building.jpg'),
              locality: getNestedValue(t, ['adresa'], 'N/A'),
              developer: price,
            },
          }
        })
        .filter((m: any) => m.position.lat && m.position.lng)
      return [this.unitMarker!, ...markers]
    },
  },
})
